import React from 'react';
import { ButtonBase, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) =>
	createStyles({
		button: {
			'width': '100%',
			'minHeight': 90,
			'flex': 1,
			'padding': theme.spacing(1.5),
			'backgroundColor': theme.palette.common.white,
			'border': `1px solid ${theme.palette.grey[300]}`,
			'borderRadius': 4,
			'boxShadow': '0 2px 8px rgba(0, 35, 110, 0.14)',
			'display': 'flex',
			'flexDirection': 'column',
			'alignItems': 'center',
			'justifyContent': 'center',
			'gap': theme.spacing(0.5),
			'textAlign': 'center',
			'transition': 'border-color 120ms ease-in-out, box-shadow 120ms ease-in-out',
			'&.Mui-disabled': {
				'cursor': 'default',
				'& $reviewAll': {
					color: theme.palette.grey[600],
				},
			},
			'&.Mui-focusVisible, &:focus-visible': {
				outline: `2px solid ${theme.palette.primary.main}`,
				outlineOffset: 2,
			},
			'&:not(.Mui-disabled):hover': {
				borderColor: theme.palette.primary.main,
			},
		},
		title: {
			fontWeight: 700,
			fontSize: theme.typography.pxToRem(18),
			lineHeight: 1.15,
			color: theme.palette.text.primary,
		},
		reviewAll: {
			fontWeight: 700,
			fontSize: theme.typography.pxToRem(11),
			lineHeight: 1.2,
			letterSpacing: theme.typography.pxToRem(0.5),
			textTransform: 'uppercase',
			color: theme.palette.primary.main,
		},
		tally: {
			fontWeight: 700,
			fontSize: theme.typography.pxToRem(38),
			lineHeight: 1,
			color: theme.palette.text.primary,
		},
	}),
);

export interface TaskCardProps {
	label: string;
	filterLabel: string;
	onClick: () => void;
	tally: number;
	disabled?: boolean;
	className?: string;
	dataField?: string;
}

export const TaskCard = ({
	label,
	filterLabel,
	onClick,
	tally,
	disabled = false,
	className,
	dataField,
}: TaskCardProps) => {
	const classes = useStyles();

	return (
		<ButtonBase
			className={classNames(classes.button, className)}
			data-field={dataField}
			onClick={onClick}
			disabled={disabled}
			aria-label={`${label}. ${filterLabel}. ${tally}`}
		>
			<Typography variant="inherit" className={classes.title}>
				{label}
			</Typography>
			<Typography variant="inherit" className={classes.reviewAll}>
				{filterLabel}
			</Typography>
			<Typography variant="inherit" className={classes.tally}>
				{tally}
			</Typography>
		</ButtonBase>
	);
};
